import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

/**
 * Lokálna časť podľa HTML5 (rovnaká množina znakov, akú validuje <input type="email">),
 * doména = aspoň dve návestia oddelené bodkou, každé začína aj končí alfanumerickým znakom.
 *
 * POZOR: pomlčka musí byť v triede znakov escapovaná alebo na konci – neescapovaná
 * medzi dvoma znakmi tvorí rozsah (pôvodné `[a-zA-Z0-9.-_]` = rozsah `.`–`_`, ktorý
 * pomlčku ani `+` neobsahoval, zato prepúšťal `@ : ; < = > ? [ \ ] ^`).
 */
const EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function emailValidator(translate: TranslateService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Prázdna hodnota nie je „nesprávny formát" - o povinnosti rozhoduje required validátor,
    // inak by sa pri nevyplnenom poli zobrazili obe hlášky naraz (ADO 57424, Figma #108).
    if (control.value === null || control.value === undefined || String(control.value).trim() === '') {
      return null;
    }
    const valid = EMAIL_PATTERN.test(control.value);
    let message = '';
    if (!valid) {
      translate.get('error.validation.email.format').subscribe((response: string) => {
        message = response;
      });
      return { invalidEmail: { value: control.value, msg: message } };
    }
    return null;
  };
}
